import React, { useState } from 'react';
import DeviceEntry from './DeviceEntry';
import { Button } from '@a2d24-ui/button/src';
import { EntryContainer, StyledChevron } from './ProjectStyledComponents';
import EmployeeEntry from './EmployeeEntry';
import VehicleEntry from './VehicleEntry';
import { archiveEntity, derosterEmployee, resetDevice, provisionHeal911 } from '../utils/api';

const ExpandableEntry = ({ type, item, setPayload, setArchive, onUpdate }) => {
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(false);

    return (
        <EntryContainer type={type} archived={item.archived}>
            {type === 'device' && <DeviceEntry device={item} />}
            {type === 'employee' && <EmployeeEntry employee={item} />}
            {type === 'vehicle' && <VehicleEntry vehicle={item} />}
            {item.archived === 'No' && (
                <Button
                    variant="text"
                    css={{
                        alignItems: 'center',
                        display: 'flex',
                        width: 'fit-content',
                        justifySelf: 'end',
                    }}
                    onClick={() => setExpanded(!expanded)}
                >
                    <StyledChevron data-state={expanded ? 'open' : 'closed'} />
                </Button>
            )}
            {expanded && item.archived === 'No' && (
                <div
                    style={{
                        gridColumn: '1 / -1',
                        display: 'flex',
                        columnGap: '20px',
                        borderTop: '0.5px solid rgba(0,0,0,0.1)',
                        padding: '10px 0 5px',
                    }}
                >
                    {type === 'device' && (
                        <>
                            <Button
                                css={{ width: 'fit-content' }}
                                onClick={() => setPayload({ ...item, popupType: 'Reassign' })}
                            >
                                Edit details
                            </Button>
                            <Button
                                css={{ width: 'fit-content' }}
                                onClick={() =>
                                    resetDevice(
                                        setLoading,
                                        null,
                                        item?.cellphone_number,
                                        item?.call_sign,
                                        'send_link',
                                        onUpdate
                                    )
                                }
                            >
                                {loading ? 'Sending...' : 'Re-send SMS'}
                            </Button>
                            {(item?.authorized === 'Yes' ||
                                item?.heal_911_authorized === 'Yes') && (
                                <Button
                                    css={{ width: 'fit-content' }}
                                    onClick={() =>
                                        resetDevice(
                                            setLoading,
                                            null,
                                            item?.cellphone_number,
                                            item?.call_sign,
                                            'revoke',
                                            onUpdate
                                        )
                                    }
                                >
                                    {loading ? 'Revoking...' : 'Revoke authorization'}
                                </Button>
                            )}
                            {item?.heal_911_authorized === 'No' && (
                                <Button
                                    css={{ width: 'fit-content' }}
                                    onClick={() =>
                                        provisionHeal911(
                                            setLoading,
                                            null,
                                            item?.cellphone_number,
                                            onUpdate
                                        )
                                    }
                                >
                                    {loading ? 'Provisioning...' : 'Provision Heal AI'}
                                </Button>
                            )}
                            {item?.archived === 'No' && (
                                <Button
                                    css={{ width: 'fit-content' }}
                                    onClick={
                                        () =>
                                            setArchive({
                                                ...item,
                                                entity: 'Device',
                                                onUpdate: onUpdate,
                                                wrapperCss: { height: 'auto', width: '45vw' },
                                            })
                                        // archiveEntity(
                                        //     setLoading,
                                        //     null,
                                        //     'Device',
                                        //     item?.cellphone_number,
                                        //     onUpdate
                                        // )
                                    }
                                >
                                    {loading ? 'Archiving...' : 'Archive'}
                                </Button>
                            )}
                        </>
                    )}
                    {type === 'employee' && (
                        <>
                            <Button css={{ width: 'fit-content' }} onClick={() => setPayload(item)}>
                                Edit details
                            </Button>
                            {item?.clock_in_vehicle && (
                                <Button
                                    css={{ width: 'fit-content' }}
                                    onClick={() =>
                                        derosterEmployee(
                                            setLoading,
                                            null,
                                            item?.employee_number,
                                            onUpdate
                                        )
                                    }
                                >
                                    {loading ? 'Derostering...' : 'Deroster'}
                                </Button>
                            )}
                            {item?.archived === 'No' && (
                                <Button
                                    css={{ width: 'fit-content' }}
                                    onClick={
                                        () =>
                                            setArchive({
                                                ...item,
                                                entity: 'Employee',
                                                onUpdate: onUpdate,
                                                wrapperCss: { height: 'auto', width: '45vw' },
                                            })
                                        // archiveEntity(
                                        //     setLoading,
                                        //     null,
                                        //     'Employee',
                                        //     item?.employee_number,
                                        //     onUpdate
                                        // )
                                    }
                                >
                                    {loading ? 'Archiving...' : 'Archive'}
                                </Button>
                            )}
                        </>
                    )}
                    {type === 'vehicle' && (
                        <>
                            <Button css={{ width: 'fit-content' }} onClick={() => setPayload(item)}>
                                Edit details
                            </Button>
                            {item?.archived === 'No' && (
                                <Button
                                    css={{ width: 'fit-content' }}
                                    onClick={
                                        () =>
                                            setArchive({
                                                ...item,
                                                entity: 'Vehicle',
                                                onUpdate: onUpdate,
                                                wrapperCss: { height: 'auto', width: '45vw' },
                                            })
                                        // archiveEntity(
                                        //     setLoading,
                                        //     null,
                                        //     'Vehicle',
                                        //     item?.call_sign,
                                        //     onUpdate
                                        // )
                                    }
                                >
                                    {loading ? 'Archiving...' : 'Archive'}
                                </Button>
                            )}
                        </>
                    )}
                </div>
            )}
        </EntryContainer>
    );
};

export default React.memo(ExpandableEntry);
